import { render, staticRenderFns } from "./PanelInputBaseRadio.vue?vue&type=template&id=828373b8&scoped=true&"
import script from "./PanelInputBaseRadio.vue?vue&type=script&lang=js&"
export * from "./PanelInputBaseRadio.vue?vue&type=script&lang=js&"
import style0 from "./PanelInputBaseRadio.vue?vue&type=style&index=0&id=828373b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828373b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('828373b8')) {
      api.createRecord('828373b8', component.options)
    } else {
      api.reload('828373b8', component.options)
    }
    module.hot.accept("./PanelInputBaseRadio.vue?vue&type=template&id=828373b8&scoped=true&", function () {
      api.rerender('828373b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanelInputBaseRadio.vue"
export default component.exports